import { render, staticRenderFns } from "./DetailSelectAnggota.vue?vue&type=template&id=3b174860&"
import script from "./DetailSelectAnggota.vue?vue&type=script&lang=js&"
export * from "./DetailSelectAnggota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports